module.exports = __webpack_public_path__ + "media/images/flag_fr-2d9b7c14231180da9bdbbb935d8a2d9e.png";